import React, { useState, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";

const MainContent = ({ handleUserAction, NavBar, userDetails }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.pathname.slice(1) || "image"
  );

  // Update activeTab when location changes
  useEffect(() => {
    const path = location.pathname.slice(1) || "image";
    setActiveTab(path);
  }, [location.pathname]);

  return (
    <div className="bg-black min-h-screen overflow-hidden flex flex-col">
      <NavBar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleUserAction={handleUserAction}
      />
      
      {/* Main content with minimal margin for NavBar */}
      <div className="flex flex-col min-h-screen md:ml-20">
        <main className="flex-1">
          {/* Content container with minimal padding */}
          <div className="bg-black min-h-screen">
            <Outlet context={{ userDetails }} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainContent;
